module.exports = __webpack_public_path__ + "assets/youtube.2f027ba9.svg";